import axios from 'axios';

$(document).ready(function() {
    if ($(window).width() > 1024) { // Adjust the width as needed for your breakpoint
        if ($('#bmux-banner-slider').length) {
            var slides = $('.bmui-banner-slide');
            var currentIndex = 0;

            function showNextSlide() {
                slides.eq(currentIndex).removeClass('active');
                currentIndex = (currentIndex + 1) % slides.length;
                slides.eq(currentIndex).addClass('active');
            }

            slides.eq(currentIndex).addClass('active');
            setInterval(showNextSlide, 5000);
        }
    }
});

$('#bmux-form').on('submit', function(event) {
    event.preventDefault();
    var formData = $(this).serialize();
    var submitButton = $(this).find('button[type="submit"]');
    var originalButtonText = submitButton.html();
    var formAction = $(this).attr('action');

    // Disable the button and show loading text
    submitButton.prop('disabled', true).html('<i class="fa fa-spinner fa-spin"></i> Please wait...');
    grecaptcha.ready(function() {
        grecaptcha.execute('6Leq3wkrAAAAAELc-6FxvxYYkqf3VVF-AtFN6oSf', {action: 'submit'}).then(function(token) {
            // Add the token to your form data
            formData += '&recaptcha_token=' + token;
            
            // Send the form with the token
            axios.post(formAction, formData, {
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            })
            .then(function(response) {
                if (response.data.status === 'success') {
                    $('#bmux-form-message').html('<div class="alert alert-success">Form submitted successfully!</div>');
                    $('#bmux-form')[0].reset(); // Clear the form fields
                } else {
                    $('#bmux-form-message').html('<div class="alert alert-danger">' + (response.data.message || 'An error occurred. Please try again.') + '</div>');
                }
            })
            .catch(function(error) {
                console.error(error);
                $('#bmux-form-message').html('<div class="alert alert-danger">An error occurred. Please try again.</div>');
            })
            .finally(function() {
                // Restore the button to its original state
                submitButton.prop('disabled', false).html(originalButtonText);
            });
        });
    });
});


